<template>
  <div>
    <Filtro-Remessas @input="load(1, $event); filtro = $event;" />
    <v-col cols="12" md="12" sm="12">
      <v-card>
        <v-card-title>Arquivos Gerados</v-card-title>
        <v-card-text>
          <v-data-table hide-default-footer :items="items" :headers="headers" :items-per-page="20">
            <template v-slot:[`item.action`]="{ item }">
              <v-btn color="success" icon @click="download(item)">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.alter_status`]="{ item }">
              <v-btn color="success" icon @click="alterStatus(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <v-chip :color="getColor(item.status)" dark>
                {{ item.status ? item.status : "Aguardando" }}
              </v-chip>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | data }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-pagination
            color="primary"
            v-model="pagination.current_page"
            :length="pagination.last_page"
            :total-visible="20"
            @input="load($event, filtro)"
          >
          </v-pagination>
        </v-card-actions>
      </v-card>
    </v-col>
    <ModalSituacao ref="modalSituacao" />
  </div>
</template>
<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";
import downloadString from "../../utils/downloadString";
import ModalSituacao from "./ModalSituacao";
import FiltroRemessas from "./FiltroRemessas";
import queryString from "querystring";

export default {
  name: "Remessa",
  components: {
    ModalSituacao,
    FiltroRemessas,
  },
  data() {
    return {
      pagination: {},
      arquivo: null,
      items: [],
      headers: [
        {
          text: "Autos",
          value: "np_arquivo.quantidade",
        },
        {
          text: "Arquivo Gráfica",
          value: "np_arquivo.arquivo_zip",
        },
        {
          text: "Arquivo Banco",
          value: "file_name",
        },
        {
          text: "Data Disponilização",
          value: "created_at",
        },
        {
          text: "Situação",
          value: "status",
        },
        {
          text: "Baixar",
          value: "action",
        },
        {
          text: "Alterar Situação",
          value: "alter_status",
        },
      ],
      filtro: {},
    };
  },
  created() {
    this.load();
  },
  methods: {
    salvar(arquivo) {
      this.$store.commit("overlay/toggle", true);
      
      var formData = new FormData();
      formData.append("arquivo", arquivo);
      
      const url = `${urlApi}/banco/remessa`;
      
      this.$http.post(url, formData).then(() => {
        this.arquivo = null;
        this.$store.commit("overlay/toggle", false);
        this.load();
      }).catch((error) => {
        showError(error);
        this.$store.commit("overlay/toggle", false);
      });
    },

    load(page = 1, event) {
      let query = queryString.stringify(event);

      const url = `${urlApi}/banco/remessa?${query}&page=${page}`;

      this.$http.get(url).then((res) => {
          const response = res.data.dados;

          this.pagination = response.remessas;
          this.items = response.remessas.data;
      }).catch((error) => {
        console.error(error);
      });
    },

    getColor(status) {
      if (status === "Finalizado") return "primary";
      if (status === "Enviado") return "success";
      if (status === "Error") return "red";
      return "";
    },

    download(item) {
      const fileName = item.file_name;
      const url = `${urlApi}/banco/remessa/download/${item.id}`;
      
      this.$http.get(url).then((res) => {
          downloadString(res.bodyText, "text/plain", fileName);
      }).catch((error) => {
        let message = error.data.message;
        let erro = error.data.data;
        
        showError(`Ops, ${message}`);
        
        setTimeout(function() {
          showError(`Avise ao Desenvolvedor, ${erro};`);
        }, 3000);
      });
    },

    async alterStatus(item) {
      const status = await this.$refs.modalSituacao.open();
      const id = item.id;
      const payload = { "status": [0].includes(status) ? null : status };
      const url = `${urlApi}/banco/remessa/${id}`;
      
      this.$http.put(url, payload).then(() => {
          this.load();
          this.$toasted.global.defaultSuccess();
      }).catch((error) => {
        const erro = error.data.message;
        showError(`${erro}`);
      });
    },
  },
};
</script>
